import { Button, Radio, Spin } from "antd";
import { AxiosError } from "axios";
import clsx from "clsx";
import { AppInput, AppSelect } from "components/input";
import { findingError } from "constants/firebaseError";
import nationInfoList from "constants/nation";
import { PHONE_REGEX } from "constants/regex";
import { useFormik } from "formik";
// import { sendOTP } from "helper/firebase";
import { useToast } from "hooks/useToast";
import { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { saveCredential } from "state/credential/credentialSlice";
import { useAppDispatch } from "state/hooks";
import { ErrorResponse } from "types/response";
import * as Yup from "yup";

interface SendOTPProps {
  title?: string;
  subTitle?: string;
  currentStep?: number;
  onChangeStep?: Function;
  onCancelSendOTP?: Function;
  onAfterVerifyStaff?: Function;
  showVerificationUserMode?: boolean;
}

const SendOTP = (props: SendOTPProps) => {
  const {
    // title = "Xác thực người dùng",
    title = "User authentication",
    // subTitle = `"Kích hoạt bảo hành"`,
    currentStep,
    onChangeStep,
    onCancelSendOTP,
    onAfterVerifyStaff,
    showVerificationUserMode = true,
  } = props;
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorField, setErrorField] = useState("");
  const [staffPhone, setStaffPhone] = useState("");
  const [staffSafeKey, setStaffSafeKey] = useState("");
  const [verifyMode, setVerifyMode] = useState("issuing");

  const { toggleToastID } = useToast();

  const formik = useFormik({
    initialValues: {
      phone: "039327831",
      nationCode: "+84",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      phone: Yup.string()
        .required("Thông tin bắt buộc!")
        .matches(PHONE_REGEX, "Số điện thoại không hợp lệ!"),
    }),
    onSubmit: async (values) => {
      handleSendOTP(values);
    },
  });

  const handleSendOTP = async (values: {
    phone: string;
    nationCode: string;
  }) => {
    if (values.phone !== "039327831" && values.phone !== "39327831") {
      setErrorMessage("Số điện thoại xác thực không hợp lệ!");
      return;
    }
    try {
      setLoading(true);
      // const response = await sendOTP(values.phone, values.nationCode);
      setTimeout(() => {
        const response = {
          verificationId: "id",
        };
        if (response?.verificationId) {
          dispatch(
            saveCredential({
              verificationId: response.verificationId,
              phone: values.phone,
              nationCode: values.nationCode,
            })
          );
          currentStep && onChangeStep && onChangeStep(currentStep + 1);
          setLoading(false);
        }
      }, 300);
    } catch (error: any) {
      let findError = findingError(error);
      setErrorMessage(findError.message);
      setLoading(false);
    }
  };

  const verifyStaffErrorHandler = (error: AxiosError<ErrorResponse>) => {
    setLoading(false);
    if (error?.response?.data?.name === "NOT_FOUND") {
      if (error?.response?.data?.message === "Account not found") {
        setErrorField("staff-phone");
        setErrorMessage("SĐT xác thực không hợp lệ");
      } else if (error?.response?.data?.message === "Business not found") {
        setErrorField("safekey");
        setErrorMessage("BlockID SafeKey không hợp lệ");
      }
      toggleToastID({
        type: "error",
        title: "Xác thực thất bại",
      });
    } else {
      toggleToastID({
        type: "error",
        title:
          "Có lỗi xảy ra trong quá trình xác thực, xin vui lòng thử lại sau!",
      });
    }
  };

  const handleVerifyStaff = async () => {
    try {
      // setLoading(true);
      // setErrorField("");
      // setErrorMessage("");
      // const apiKey = process.env.NEXT_PUBLIC_FRONTEND_API_KEY || "";
      // const encSafeKey = CryptoJS.AES.encrypt(staffSafeKey, apiKey).toString();
      // const response = await authApi.signInWithSafeKey({
      //   safe_key_encrypt: encSafeKey,
      //   last4_phone_number: staffPhone,
      // });
      // setLoading(false);
      // if (response?.data?.success && response?.data?.data?.token) {
      //   const token = response.data.data.token;
      //   toggleToastID({
      //     type: "success",
      //     title: "Xác thực thành công!",
      //   });
      //   dispatch(
      //     saveCredential({
      //       initialIdToken: token,
      //       idToken: token,
      //       isStaff: true,
      //       safeKey: staffSafeKey,
      //     }),
      //   );
      // }
      onAfterVerifyStaff && onAfterVerifyStaff();
    } catch (error) {
      verifyStaffErrorHandler(error as AxiosError<ErrorResponse>);
    }
  };

  useEffect(() => {
    setErrorField("");
    setErrorMessage("");
  }, [verifyMode]);

  return (
    <>
      <h4 className="text-md lg:text-xl font-bold text-center mb-1">{title}</h4>
      {showVerificationUserMode ? (
        <>
          <p className="text-xs lg:text-sm font-normal text-center">
            {/* Để bảo mật dữ liệu, xin vui lòng xác minh thông tin phía dưới */}
            To protect the data, please verify the information below.
          </p>
          <div className="mx-2 my-4 py-3 border-y-[1px] border-solid border-[#E4E7EC] flex flex-col lg:flex-row items-center justify-center self-stretch">
            <p className="mr-3 fw-600 mb-2 lg:mb-0">
              {/* Bạn là: */}
              You are:
            </p>
            <div>
              <Radio
                disabled
                onClick={() => setVerifyMode("owner")}
                checked={verifyMode === "owner"}
                className="radio radio-dark"
              >
                <span className="font-semibold">
                  {/* Chủ sở hữu */}
                  Owner
                </span>
              </Radio>
              <Radio
                onClick={() => setVerifyMode("issuing")}
                checked={verifyMode === "issuing"}
                className="radio radio-dark"
              >
                <span className="font-semibold uppercase">
                  {/* Đơn vị cấp */}
                  Issuer
                </span>
              </Radio>
            </div>
          </div>
        </>
      ) : null}
      <p className="mb-4 text-sm lg:text-md text-center">
        {/* Xác thực <span className="font-semibold">số điện thoại của bạn</span> để
        xác minh nhân viên thuộc đơn vị cấp */}
        Verify <span className="font-semibold">your phone number</span> to
        confirm your affiliation with the Issuer.
      </p>
      {loading ? (
        <Spin spinning size="large" className="my-4" />
      ) : verifyMode === "issuing" ? (
        <>
          <div className="mb-4 w-full max-w-[400px]">
            <div className="flex items-start">
              <AppSelect
                value={formik.values.nationCode}
                items={nationInfoList.map((item) => ({
                  title: item.name,
                  value: item.phoneId,
                  data: item,
                }))}
                selectClassName="rounded-r-none border-r-none !px-2"
                onChangeValue={(value) => {
                  !Array.isArray(value) &&
                    formik.setFieldValue("nationCode", value.value);
                }}
                TitleComponent={({ title, data }) => {
                  return (
                    <div className="flex items-center justify-start w-[70px]">
                      <div className="w-[20px] h-[20px] lg:w-[28px] lg:h-[28px] relative flex items-center">
                        <img src={data?.image || ""} alt="" />
                      </div>
                      <p className="ml-2">({data?.phoneId || ""})</p>
                    </div>
                  );
                }}
                OptionComponent={({ data }) => {
                  return (
                    <div className="flex items-center justify-start w-[70px] ml-2">
                      <div className="w-[20px] h-[20px] lg:w-[28px] lg:h-[28px] relative flex items-center">
                        <img src={data?.image || ""} alt="" />
                      </div>
                      <p className="ml-2">({data?.phoneId || ""})</p>
                    </div>
                  );
                }}
              />
              <AppInput
                containerClassName="flex-1"
                inputClassName="!rounded-l-none input-no-spin"
                placeholder="Số điện thoại của bạn"
                invalid={
                  (formik.touched.phone && formik.errors.phone) || errorMessage
                    ? true
                    : false
                }
                invalidText={formik.errors.phone || errorMessage}
                type="number"
                {...formik.getFieldProps("phone")}
                onChange={(e) =>
                  formik.setFieldValue("phone", e.target.value.toString())
                }
              />
            </div>
          </div>
          <div className="self-stretch flex mt-4">
            <Button
              onClick={() => {
                formik.resetForm();
                onCancelSendOTP && onCancelSendOTP();
              }}
              className="btn btn-outline btn-outline-dark px-4 py-2 mr-2 flex-1"
            >
              {/* Huỷ */}
              Cancel
            </Button>
            <Button
              className="btn btn-primary px-4 py-2 flex-1 ml-2"
              onClick={formik.submitForm}
            >
              {/* Xác nhận */}
              Confirm
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col items-center justify-center">
            <p className="text-sm font-semibold mb-2 lg:mb-3">
              {/* 4 số cuối số điện thoại của bạn */}
              Last 4 digits of your phone number
            </p>
            <OTPInput
              inputType="number"
              value={staffPhone}
              onChange={setStaffPhone}
              numInputs={4}
              renderSeparator={<div className="mx-1 sm:mx-3 lg:mx-5"></div>}
              renderInput={(props) => (
                <input
                  {...props}
                  className={clsx(
                    "input-no-spin !w-[40px] !h-[40px] !outline-none p-3 rounded-lg !border-[1px] !border-solid text-center  !text-md md:!text-sm !border-[#C5C6CC] focus:!border-dark-100",
                    {
                      "!border-danger":
                        errorMessage && errorField === "staff-phone",
                    }
                  )}
                />
              )}
            />
            <p className="text-sm font-semibold my-2 lg:my-5">và</p>
            <p className="text-sm font-semibold mb-2 lg:mb-3">
              BlockID SafeKey
            </p>
            <OTPInput
              inputType="number"
              value={staffSafeKey}
              onChange={setStaffSafeKey}
              numInputs={6}
              renderSeparator={<div className="mx-1 sm:mx-3 lg:mx-5"></div>}
              renderInput={(props) => (
                <input
                  {...props}
                  className={clsx(
                    "input-no-spin !w-[40px] !h-[40px] !outline-none p-3 rounded-lg !border-[1px] !border-solid text-center  !text-md md:!text-sm !border-[#C5C6CC] focus:!border-dark-100",
                    {
                      "!border-danger":
                        errorMessage && errorField === "safekey",
                    }
                  )}
                />
              )}
            />
            {errorField && (
              <p className="text-danger text-sm font-semibold mt-4">
                {errorMessage}
              </p>
            )}
          </div>
          <div className="self-stretch flex mt-6">
            <Button
              onClick={() => {
                onCancelSendOTP && onCancelSendOTP();
              }}
              className="btn btn-outline btn-outline-primary px-4 py-2 mr-2 flex-1"
            >
              {/* Huỷ */}
              Cancel
            </Button>
            <Button
              className="btn btn-primary px-4 py-2 flex-1 ml-2"
              onClick={handleVerifyStaff}
            >
              {/* Xác nhận */}
              Confirm
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default SendOTP;
